import { render } from "./ProviderSelection.vue?vue&type=template&id=61873eb5"
import script from "./ProviderSelection.vue?vue&type=script&lang=js"
export * from "./ProviderSelection.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__